import { render } from "./EsimRatesModal.vue?vue&type=template&id=10ce1fc3&ts=true"
import script from "./EsimRatesModal.vue?vue&type=script&lang=ts"
export * from "./EsimRatesModal.vue?vue&type=script&lang=ts"

import "./EsimRatesModal.vue?vue&type=style&index=0&id=10ce1fc3&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__